import { Component, Input, OnInit } from "@angular/core";
import { Profile } from "../../../../shared";

@Component({
  selector: "profile-nav-tabs",
  templateUrl: "./profile-nav-tabs.component.html",
  styleUrls: [
    "./profile-nav-tabs.component.scss",
    "../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class ProfileNavTabsComponent implements OnInit {
  constructor() {}
  @Input() profile: Profile;
  @Input() ownsProfile: boolean = false;
  ngOnInit() {}
}
